<div class="uk-width-1-1">
    <nav class="uk-navbar-container uk-navbar-transparent background-dark-grey topnav" uk-navbar>
        <div class="uk-navbar-left">
            <a [routerLink]="['']" class="uk-navbar-item uk-logo logo">
                <img src="../../../assets/logo/vop.svg">
            </a>
            <ul class="uk-navbar-nav role-select" style="margin-left: 50px;">
                <li>
                    Administration
                </li>
            </ul>
        </div>

        <div class="uk-navbar-center" style="top: 65%;" *ngIf="session.role.ability == 'super-admin'">
            <app-multi-search></app-multi-search>
        </div>


        <div class="uk-navbar-right">
            <ul class="uk-navbar-nav session-name">
                <li class="role-name">
                    <a *ngIf="session.role.name !== ''" href="javascript: void(0);">
                        {{ session.role.name }}
                    </a>
                    <a *ngIf="session.role.name === '' && session.role.ability === 'admin'" href="javascript: void(0);">
                        Administrateur
                    </a>
                    <a *ngIf="session.role.name === '' && session.role.ability === 'super-admin'"
                        href="javascript: void(0);">
                        Super-Administrateur
                    </a>
                </li>
                <li>
                    <a class="logout" href="javascript: void(0);" (click)="logout()">
                        <img src="../../../assets/icons/Load.svg" width="32px" height="32px">
                    </a>
                </li>
            </ul>
        </div>
    </nav>
    <nav class="uk-navbar-container uk-navbar-transparent background-grey linknav" uk-navbar>
        <div class="uk-navbar-center">
            <ul class="uk-navbar-nav" *ngIf="menu.active.type === 'company'">
                <li>
                    <a [routerLink]="['company/informations']">
                        <span class="bold" [class.color-orange]="menu.active.menu === 'company'">Informations
                            entreprise</span>
                    </a>
                </li>
                <li>
                    <a [routerLink]="['reservation/list']">
                        <span class="bold" [class.color-orange]="menu.active.menu === 'reservation'">Réservations</span>
                    </a>
                </li>
            </ul>
            <ul class="uk-navbar-nav" *ngIf="menu.active.type === 'default'">
                <!-- <li *ngIf="session.role.ability === 'super-admin'">
                    <a [routerLink]="['carte']">
                        <span class="bold" [class.color-orange]="menu.active.menu === 'carte'">Carte</span>
                    </a>
                </li> -->
                <li *ngIf="session.role.ability === 'admin' || session.role.ability === 'super-admin'">
                    <a [routerLink]="['']"
                        (click)="menu.setMenuState('dashboard', 'activity', ''); title.setTitle('Tableau de bord / VOP');">
                        <span class="bold" [class.color-orange]="menu.active.menu === 'dashboard'">Tableau de
                            bord</span>
                    </a>
                </li>
                <li *ngIf="session.role.ability === 'super-admin'">
                    <a [routerLink]="['user/society/list']">
                        <span class="bold" [class.color-orange]="menu.active.menu === 'adherent'">Adhérents</span>
                    </a>
                </li>
                <!--                                 
                    Alert service has been disabled

                    <li>
                    <a href="#offcanvas-usage" uk-toggle>
                        <span *ngIf="alert.alertCount > 0" class="uk-badge">{{ alert.alertCount }}</span>
                        <i *ngIf="alert.alertCount === 0" style="font-size: 21px !important;" class="material-icons">
                            notifications_active
                        </i>
                        <span style="margin-left: 10px">Alertes</span>
                    </a>
                </li> -->


                <!-- User test -->
                <li *ngIf="session.role.ability === 'user'">
                    <a [routerLink]="['user/me']">
                        <span class="bold" [class.color-orange]="menu.active.menu === 'user'">Mes Informations</span>
                    </a>
                </li>
                <li *ngIf="session.role.ability === 'user'">
                    <a [routerLink]="['reservation/me']">
                        <span class="bold" [class.color-orange]="menu.active.menu === 'reservation'">Réservations</span>
                    </a>
                </li>
                <!-- User test -->

                <li *ngIf="session.role.ability === 'super-admin' || session.role.ability === 'admin'">
                    <a [routerLink]="['ressource/vehicle/list']">
                        <span class="bold" [class.color-orange]="menu.active.menu === 'ressource'">Véhicules &
                            Stations</span>
                    </a>
                </li>
                <li *ngIf="session.role.ability === 'super-admin' || session.role.ability === 'admin'">
                    <a [routerLink]="['user/list']">
                        <span class="bold" [class.color-orange]="menu.active.menu === 'user'">Utilisateurs</span>
                    </a>
                </li>

                <li *ngIf="session.role.ability === 'super-admin' || session.role.ability === 'admin'">
                    <a [routerLink]="['reservation/list']">
                        <span class="bold" [class.color-orange]="menu.active.menu === 'reservation'">Réservations</span>
                    </a>
                </li>

                <li *ngIf="session.role.ability == 'super-admin'">
                    <!--| session.role.ability === 'admin' -->
                    <a>
                        <!-- [routerLink]="['facturation/virements']" -->
                        <span class="bold" uk-tooltip="En cour de développement"
                            [class.color-orange]="menu.active.menu === 'facturation'">Facturations</span>
                    </a>
                </li>
            </ul>
        </div>
    </nav>
    <nav class="uk-navbar-container uk-navbar-transparent background-grey linknav-responsive" uk-navbar>
        <ul class="uk-navbar-nav">
            <li class="uk-margin-small-left">
                <a (click)="toggleResponsiveMenu()">
                    <span class="bold" *ngIf="menu.active.menu === 'adherent'">Adhérents</span>
                    <span class="bold" *ngIf="menu.active.menu === 'dashboard'">Tableau de bord</span>
                    <span class="bold" *ngIf="menu.active.menu === 'ressource'">Véhicules & Stations</span>
                    <span class="bold" *ngIf="menu.active.menu === 'user'">Utilisateurs</span>
                    <span class="bold" *ngIf="menu.active.menu === 'reservation'">Réservations</span>
                    <!-- <span class="bold" *ngIf="menu.active.menu === 'facturation'">Facturation</span> -->
                    <img src="../../../../assets/icons/ArrowDown.svg" height="32px" width="32px"
                        style="filter: brightness(100);">
                </a>
            </li>
        </ul>
    </nav>
</div>

<div id="responsive-menu" class="uk-offcanvas" [class.hidden]="isResponsiveMenuActive === false">
    <ul class="uk-nav" style="position: absolute; top: 10px; left: 10px;">
        <li class="role-name">
            <a *ngIf="session.role.name !== ''" href="javascript: void(0);">
                {{ session.role.name }}
            </a>
            <a *ngIf="session.role.name === '' && session.role.ability === 'admin'" href="javascript: void(0);">
                Administrateur
            </a>
            <a *ngIf="session.role.name === '' && session.role.ability === 'super-admin'" href="javascript: void(0);">
                Super-Administrateur
            </a>
        </li>
        <li *ngIf="session.role.ability === 'super-admin'" class="uk-margin-top">
            <a [routerLink]="['user/society/list']" (click)="toggleResponsiveMenu()">
                <span class="bold" [class.color-orange]="menu.active.menu === 'adherent'">Adhérents</span>
            </a>
        </li>
        <li *ngIf="session.role.ability === 'admin'" (click)="toggleResponsiveMenu()" class="uk-margin-top">
            <a [routerLink]="['']"
                (click)="menu.setMenuState('dashboard', 'activity', ''); title.setTitle('Tableau de bord / VOP');">
                <span class="bold" [class.color-orange]="menu.active.menu === 'dashboard'">Tableau de bord</span>
            </a>
        </li>
        <!--
            Alert service has been disabled

            <li>
            <a href="#offcanvas-usage" uk-toggle>
                <span *ngIf="alert.alertCount > 0" class="uk-badge">{{ alert.alertCount }}</span>
                <i *ngIf="alert.alertCount === 0" style="font-size: 21px !important;" class="material-icons">
                    notifications_active
                </i>
                <span style="margin-left: 10px">Alertes</span>
            </a>
        </li>-->
        <li>
            <a [routerLink]="['ressource/vehicle/list']" (click)="toggleResponsiveMenu()">
                <span class="bold" [class.color-orange]="menu.active.menu === 'ressource'">Véhicules & Stations</span>
            </a>
        </li>
        <li>
            <a [routerLink]="['user/list']" (click)="toggleResponsiveMenu()">
                <span class="bold" [class.color-orange]="menu.active.menu === 'user'">Utilisateurs</span>
            </a>
        </li>
        <li>
            <a [routerLink]="['reservation/list']" (click)="toggleResponsiveMenu()">
                <span class="bold" [class.color-orange]="menu.active.menu === 'reservation'">Réservations</span>
            </a>
        </li>
        <li>
            <a [routerLink]="['facturation/virements']" (click)="toggleResponsiveMenu()">
                <span class="bold" [class.color-orange]="menu.active.menu === 'facturation'">Facturation</span>
            </a>
        </li>
    </ul>
    <a (click)="toggleResponsiveMenu()" style="position: absolute; top: 10px; right: 10px;">
        <img src="../../../../assets/icons/Close.svg" height="32px" width="32px" style="filter: brightness(100);">
    </a>
    <ul class="uk-navbar-nav" style="position: absolute; bottom: 10px; left: 10px;">
        <li>
            <a class="logout" href="javascript: void(0);" (click)="logout()">
                <span>Se déconnecter</span>
                <img src="../../../assets/icons/Load.svg" width="32px" height="32px">
            </a>
        </li>
    </ul>
</div>